module.exports = __webpack_public_path__ + "static/media/trial3_3.adbd5401.png";